import React from 'react';

import Typography from '@mui/material/Typography';

import { RenderElementProps } from 'slate-react';

import { LOGICAL_OPERATOR_COLOR } from '../constants';
import { LogicalOperatorElement as LogicalOperatorElementType } from '../types';

interface LogicalOperatorRenderProps extends RenderElementProps {
  element: LogicalOperatorElementType;
}

export const LogicalOperatorElement: React.FC<LogicalOperatorRenderProps> = ({
  attributes,
  element,
}) => {
  return (
    <Typography
      component="span"
      variant="body2"
      {...attributes}
      sx={{
        alignItems: 'center',
        color: LOGICAL_OPERATOR_COLOR,
        display: 'inline-flex',
        px: 0.5,
        whiteSpace: 'normal',
      }}
    >
      {element.operator}
    </Typography>
  );
};
